<template>
        <section id="cta-11" class="cta-section division mt-4 pt-60 pd-60">
            <div class="container">
                <div class="">
                    <div class="row d-flex align-items-center">


                        <!-- CALL TO ACTION TEXT -->
                        <div class="col-lg-7 col-lg-7">
                            <div class="cta-11-txt">

                                <!-- Title -->
                                <h3 class="h2-xs">Ready to Join CREDITFIXRR.COM?</h3>

                                <!-- Text -->
                                <p class="p-lg">Access our Dispute Flows & Discover all the tools and information you need in order to discharge debt from your consumer credit reports.
                                </p>

                                <!-- Button -->
                                <a href="#plan" class="btn btn-stateblue tra-stateblue-hover">Get Started Now</a>

                            </div>
                        </div>


                        <!-- CALL TO ACTION BUTTON -->
                        <div class="col-lg-5">
                            <div class="text-end">
                                <div class="cta-11-img text-center">
                                    <img class="img-fluid" src="/landing/images/creditfixrr.png" alt="cta-image">
                                </div>
                            </div>
                        </div>


                    </div>
                </div>    <!-- End row -->
            </div>	   <!-- End container -->
        </section>	<!-- END CALL TO ACTION-11 -->
</template>
